export const defaultSettings = {
  text: 'blocks.button.default.text',
  url: '##confirmation_link##',
  width: '220',
  height: '40',
  fontSize: '14',
  borderRadius: '3',
  backgroundColor: '#444444',
  textColor: '#ffffff',
  align: 'center',
}
